// Generates a deterministic device/hardware fingerprint for anti-abuse
export const getDeviceFingerprint = () => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let canvasHash = '';
    if (ctx) {
      canvas.width = 200;
      canvas.height = 50;
      ctx.textBaseline = 'top';
      ctx.font = '14px Arial';
      ctx.fillStyle = '#1796C3';
      ctx.fillRect(10, 10, 80, 20);
      ctx.fillStyle = '#111827';
      ctx.fillText('Yooki-Device-ID', 15, 15);
      canvasHash = canvas.toDataURL();
    }

    let glRenderer = '';
    try {
      const gl = document.createElement('canvas').getContext('webgl');
      if (gl) {
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
          glRenderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '';
        }
      }
    } catch {
      // webgl disabled or unavailable
    }

    const screenObj = typeof window !== 'undefined' ? window.screen : null;
    const components = [
      navigator.userAgent,
      navigator.language,
      (screenObj ? `${screenObj.width}x${screenObj.height}` : '0x0'),
      (screenObj ? screenObj.colorDepth : 24),
      navigator.hardwareConcurrency || 4,
      Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      canvasHash.slice(-50),
      glRenderer
    ];

    // Simple robust hash function
    let hash = 0;
    const str = components.join('###');
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash |= 0;
    }
    return 'fp_' + Math.abs(hash).toString(36);
  } catch (err) {
    return 'fp_fallback_' + Math.random().toString(36).substring(2, 10);
  }
};
